import findComposeViewStateById, { IdSource } from '../utils/findComposeViewStateById';
import { refreshSharingTips } from '../utils/refreshSharingTips';
import { refreshSharingTipsForAttachment } from 'owa-attachment-model-store';
import { refreshSharingTipsForLink, removeSharingLink } from 'owa-link-data';
import { orchestrator } from 'satcheljs';
import { removeLinksThenRefreshSharingTips } from 'owa-attachment-well-data';

orchestrator(refreshSharingTipsForLink, actionMessage => {
    const viewState = findComposeViewStateById(actionMessage.linkId, IdSource.Link);
    if (viewState !== null) {
        refreshSharingTips(viewState);
    }
});

orchestrator(refreshSharingTipsForAttachment, actionMessage => {
    const viewState = findComposeViewStateById(actionMessage.attachmentId, IdSource.Attachment);
    if (viewState !== null) {
        refreshSharingTips(viewState);
    }
});

orchestrator(removeLinksThenRefreshSharingTips, actionMessage => {
    if (actionMessage.linkIds.length < 1) {
        return;
    }
    const viewState = findComposeViewStateById(actionMessage.linkIds[0], IdSource.Link);

    if (viewState !== null) {
        actionMessage.linkIds.forEach(id =>
            removeSharingLink(id, viewState.attachmentWell.sharingLinkIds)
        );
        refreshSharingTips(viewState);
    }
});
